import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class SelectTrashRow extends Action<StorymapState> {
    public static ACTION_TYPE = 'SelectTrashRow';

    public constructor(public rowId: string) {
        super(SelectTrashRow.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SelectTrashRow): void => {
    state.trashState.selectedRowId = state.trashState.selectedRowId === action.rowId ? null : action.rowId;
};

//@ts-ignore
registerReducer(SelectTrashRow.ACTION_TYPE, reducer);
